"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Linkify = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var urlRegex = /\[(.+)\]\((https?:\/\/[^\s]+)\)|(https?:\/\/[^\s)]+)|\[(.+)\]\((tel:[\d]+)\)/ig;

var detectLinksInText = function detectLinksInText(text) {
  var parts;
  var previousIndex = 0;
  var parsedItems = [];

  while ((parts = urlRegex.exec(text)) !== null) {
    // eslint-disable-line
    var textPart = text.substr(previousIndex, parts.index - previousIndex);

    if (textPart) {
      parsedItems.push(textPart);
    }

    if (parts[1]) {
      parsedItems.push({
        href: parts[2],
        label: parts[1]
      });
    } else if (parts[3]) {
      parsedItems.push({
        href: parts[3],
        label: parts[3]
      });
    } else if (parts[4]) {
      parsedItems.push({
        href: parts[5],
        label: parts[4]
      });
    }

    previousIndex = urlRegex.lastIndex;
  }

  var remainingText = text.substr(previousIndex);

  if (remainingText) {
    parsedItems.push(remainingText);
  }

  return parsedItems;
};

var Linkify = function Linkify(_ref) {
  var text = _ref.text;
  var parsedItems = detectLinksInText(text || '');

  var handleClick = function handleClick(url) {
    // eslint-disable-next-line no-console
    console.log('=== Linkify handleClick', url);
  };

  return _react["default"].createElement("span", null, parsedItems.map(function (part, index) {
    return typeof part === 'string' ? _react["default"].createElement("span", {
      key: index
    }, part) : _react["default"].createElement("a", {
      onClick: function onClick() {
        return handleClick(part.href);
      },
      key: index // eslint-disable-next-line react/jsx-no-target-blank
      ,
      target: "_blank",
      href: part.href
    }, part.label);
  }));
};

exports.Linkify = Linkify;
Linkify.propTypes = {
  text: _propTypes["default"].string.isRequired
};
var _default = Linkify;
exports["default"] = _default;